<template>
  <div>
    <div class="container">
      <PushNotificationsOptIn
        v-if="studio && showPushNotificationsOptIn"
        class="mt-4"
      ></PushNotificationsOptIn>
      <StudioAnnouncement
        class="mt-4"
        v-if="studio && studio.announcement"
        :announcement="studio.announcement"
      ></StudioAnnouncement>
      <NuxtLink
        class="undecorated-router-link mt-4 d-block"
        :to="{ name: 'studio-products', hash: '#class-cards-credits' }"
        v-if="numberOfThisStudioPunches"
      >
        <HMButton color="outline-gray" class="w-100 d-md-none">
          <div class="w-100 d-flex justify-content-between align-items-center">
            <span class="me-2"> {{ $t('PRODUCTS.LABELS.CLASSCARDS') }}: </span>
            <span class="ms-2">
              <i class="fal fa-ticket-alt c-brand-color me-2 rotate-35"></i>
              {{ numberOfThisStudioPunches }}
            </span>
          </div>
        </HMButton>
      </NuxtLink>

      <div
        class="row mt-4"
        v-if="
          isLatestMediaViewsLoading &&
          isCourseProgressLoading &&
          isUpcomingStudioEventsLoading
        "
      >
        <div class="col-12 text-center">
          <HMSpinner />
        </div>
      </div>

      <div class="row" v-if="myProducts && !myProducts.length">
        <div class="col-12">
          <div class="border rounded mt-4">
            <div class="row">
              <div class="col-12 col-md-10 col-lg-7 mx-auto">
                <HMNoDataCard
                  :showBorder="false"
                  :title="$t('STUDIO.TITLE.NO_PRODUCTS_TO_SHOW')"
                  :description="
                    $t('STUDIO.TEXT.ONCE_YOU_HAVE_PURCHASED_A_PRODUCT_YOUR')
                  "
                  toRouteName="studio-shop"
                  :toLabel="$t('STUDIO.BUTTON.BROWSE_PRODUCTS')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="myProducts && myProducts.length">
        <div class="col-12 col-lg-5 mt-4">
          <div class="border p-4 rounded h-100" v-if="firstMediaView">
            <h3 class="mb-4">
              {{ $t('STUDIO.TITLE.PICK_UP_WHERE_YOU_LEFT_OFF') }}:
            </h3>
            <NuxtLink
              class="undecorated-router-link"
              :to="firstMediaView.relative_url"
            >
              <StudioMediaCard :media="firstMediaView.media" />
            </NuxtLink>
          </div>
          <HMNoDataCard
            v-else
            class="h-100"
            :title="$t('STUDIO.TITLE.NO_RECENTLY_VIEWED_MEDIA')"
            :description="$t('STUDIO.TEXT.ONCE_YOU_VIEW_MEDIA_PRODUCT')"
            toRouteName="studio-shop"
            :toLabel="$t('STUDIO.BUTTON.BROWSE_PRODUCTS')"
          />
        </div>
        <div class="col-12 col-lg-7 mt-4">
          <HMNoDataCard
            v-if="!studio.has_events"
            class="h-100"
            :title="$t('STUDIO.TITLE.UPCOMING_EVENTS')"
            :description="
              $t(
                'STUDIO.TEXT.THERE_ARE_NO_UPCOMING_EVENTS_AVAILABLE_AT_THE_STUDIO'
              )
            "
          />
          <div
            class="border p-4 rounded h-100 d-flex align-items-center justify-content-center"
            v-else-if="isUpcomingStudioEventsLoading"
          >
            <HMSpinner />
          </div>
          <div
            class="border p-4 rounded h-100"
            v-else-if="upcomingStudioEvents && upcomingStudioEvents.length"
          >
            <div class="d-flex justify-content-between align-items-center">
              <h3 class="mb-4">{{ $t('STUDIO.TITLE.UPCOMING_EVENTS') }}:</h3>
            </div>
            <CompactEventsList
              :events="upcomingStudioEvents"
              :maxEvents="5"
              :openInNewWindow="false"
            />
          </div>
          <HMNoDataCard
            v-else
            class="h-100"
            :title="$t('STUDIO.TITLE.UPCOMING_EVENTS')"
            :description="
              $t(
                'STUDIO.TEXT.ONCE_YOU_REGISTER_FOR_AN_EVENT_OR_JOIN_THE_WAITLIST'
              )
            "
            toRouteName="studio-calendar"
            :toLabel="$t('STUDIO.BUTTON.BROWSE_CALENDAR')"
          />
        </div>
        <div class="col-12 mt-4">
          <div class="border pt-4 px-4 rounded">
            <div class="row">
              <div class="col">
                <h3 class="mb-4">{{ $t('GENERAL.LINK.MY_PRODUCTS') }}:</h3>
              </div>
              <div class="col">
                <NuxtLink
                  class="undecorated-router-link float-end"
                  :to="{ name: 'studio-products' }"
                >
                  <HMButton color="outline-gray">
                    {{ $t('STUDIO.LABELS.ALL_PRODUCTS') }}
                  </HMButton>
                </NuxtLink>
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 col-md-4"
                v-for="product in myProducts"
                :key="product.id"
              >
                <NuxtLink
                  class="undecorated-router-link"
                  :to="{
                    name: 'studio-product',
                    params: { product_id: product.id },
                  }"
                >
                  <StudioProductCard
                    :product="product"
                    size="sm"
                    :static="true"
                  />
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-12 mt-4"
          v-if="othersMediaViews && othersMediaViews.length"
        >
          <div class="border p-4 rounded">
            <h3 class="mb-4">{{ $t('STUDIO.TITLE.RECENTLY_VIEWED') }}:</h3>
            <div class="row">
              <div
                class="col-12 col-md-6 col-lg-3"
                v-for="mediaView in othersMediaViews"
                :key="mediaView.media.id"
              >
                <NuxtLink
                  class="undecorated-router-link"
                  :to="mediaView.relative_url"
                >
                  <StudioMediaCard :media="mediaView.media" />
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RefreshData from '@/mixins/refreshData';
import { mapState } from 'pinia';
import { useUserStore, useStudioStore } from '~/stores';
import CompactEventsList from '~/components/events/CompactEventsList.vue';
import StudioAnnouncement from '~/components/shop/StudioAnnouncement.vue';
import PushNotificationsOptIn from '~/components/shop/PushNotificationsOptIn.vue';
import StudioProductCard from '~/components/products/StudioProductCard.vue';
import StudioMediaCard from '~/components/products/StudioMediaCard.vue';
import studiosApi from '~/api/studios';
import { errorToMessage } from '@/utils/errors';

export default {
  name: 'StudentDashboard',
  components: {
    CompactEventsList,
    StudioAnnouncement,
    StudioProductCard,
    StudioMediaCard,
    PushNotificationsOptIn,
  },
  mixins: [RefreshData],
  data() {
    return {
      isLatestMediaViewsLoading: true,
      isCourseProgressLoading: true,
      isUpcomingStudioEventsLoading: true,

      latestMediaViews: undefined,
      courseProgress: undefined,
      upcomingStudioEvents: undefined,
      showPushNotificationsOptIn: false,
    };
  },
  setup() {
    definePageMeta({
      name: 'studio-dashboard',

      isStudio: true,
      requiresAuth: true,
      hideInstagramSlider: true,
      showStudentNavigation: true,
    })
  },
  computed: {
    ...mapState(useStudioStore, {
      studio: 'currentStudio',
      isOwner: 'isOwner'
    }),
    ...mapState(useUserStore, {
      numberOfThisStudioPunches: 'numberOfThisStudioPunches',
      punches: 'punches',
    }),
    sortedProducts() {
      if (!this.studio || !this.studio.products) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.studio.products.sort((p1, p2) => p1.position - p2.position);
    },
    getPurchasedProducts() {
      if (this.isOwner) return this.sortedProducts;
      return this.sortedProducts.filter(product => product.purchased);
    },
    studioURL() {
      return this.$studioURL;
    },
    quizzesSearchQuery() {
      return {};
    },
    firstMediaView() {
      return this.latestMediaViews?.[0];
    },
    othersMediaViews() {
      return this.latestMediaViews?.slice(1);
    },
    myProducts() {
      if (!this.courseProgress || !this.punches) {
        return undefined;
      }

      const purchasedProductsIds = this.getPurchasedProducts.map(
        product => product.id
      );
      const courseProgress = this.courseProgress
        .filter(
          course =>
            course.progress !== 100 && purchasedProductsIds.includes(course.id)
        )
        .slice(0, 3);
      const courseProgressIds = courseProgress.map(({ id }) => id);
      const otherPurchasedProducts = this.getPurchasedProducts
        .filter(product => !courseProgressIds.includes(product.id))
        .slice(0, 3 - courseProgress.length);

      return [...courseProgress, ...otherPurchasedProducts];
    },
  },
  methods: {
    async loadData() {
      useStudioStore()
        .getLatestMediaViews(this.studioURL)
        .then(latestMediaViews => {
          this.latestMediaViews = latestMediaViews;
        })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to load your dashboard',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        })
        .finally(() => {
          this.isLatestMediaViewsLoading = false;
        });

      useStudioStore()
        .getCourseProgress(this.$studioURL)
        .then(courseProgress => {
          this.courseProgress = courseProgress;
        })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to load your dashboard',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        })
        .finally(() => {
          this.isCourseProgressLoading = false;
        });

      studiosApi
        .getUpcomingStudioEvents(this.$studioURL, undefined, true)
        .then(upcomingStudioEvents => {
          this.upcomingStudioEvents = upcomingStudioEvents;
        })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to load your dashboard',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        })
        .finally(() => {
          this.isUpcomingStudioEventsLoading = false;
        });

      if (this.studio.push_notifications_enabled) {
        const ptExists = await this.pushTokenExists();
        if (!ptExists) {
          this.showPushNotificationsOptIn = true;
        }
      }
    },
    async pushTokenExists() {
      const messaging = this.$firebase.messaging();
      try {
        const currentToken = await messaging.getToken({
          vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
        });
        if (!currentToken) return false;
        const tokenExists = await useStudioStore().pushTokenExists({
          studioURL: this.$studioURL,
          token: currentToken,
        });
        return tokenExists.exists;
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

:deep(.icon-container .icon) {
  border-radius: $border-radius;
}

:deep(.btn-container .add-button) {
  border-radius: $border-radius;
  padding: 4px 8px;
}
</style>